module.exports = __webpack_public_path__ + "img/D.b5a98b4a.png";